export const SIDEBAR_ITEMS = [
  {
    id: 'commandCenter',
    label: 'Insights',
    icon: 'LayoutDashboard',
    path: '/dashboard',
    active: false
  },
  {
    id: 'aiops',
    label: 'AIOps',
    icon: 'Orbit',
    hasSubItems: true,
    expanded: false,
    subItems: [
      // {
      //   id: 'impactAnalysis',
      //   label: 'Impact Analysis',
      //   icon: 'Orbit',
      //   path: '/impactAnalysis',
      //   active: false
      // },
      {
        id: 'recommendationCenter',
        label: 'Recommendation Center',
        icon: 'CircleAlert',
        path: '/recommendation-center',
        active: false
      },
      {
        id: 'actionCenter',
        label: 'Action Center',
        icon: 'Zap',
        path: '/action-center',
        active: false
      }
    ]
  },
  {
    id: 'knowledgeCenter',
    label: 'Knowledge Center',
    icon: 'Database',
    path: '/corp-it-knowledge',
    active: false
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Wrench',
    path: '/settings',
    active: false
  }
];

export const INCIDENT_STATUS = {
  ACTIVE: 'active',
  RESOLVED: 'resolved',
  PENDING: 'pending'
};

export const INTEGRATION_STATUS = {
  CONNECTED: 'connected',
  ERROR: 'error',
  DISCONNECTED: 'disconnected'
};

export const THEME_COLORS = {
  primary: {
    50: '#eff6ff',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8'
  },
  success: {
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a'
  },
  warning: {
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04'
  },
  error: {
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626'
  },
  gray: {
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  }
};

